import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import {
    // FR
    frShopPage,
    frProductPage,
    frCartPage,
    frFormInputs,
    frInputs,
    frErrors,
    frFooter,
    // EN
    enShopPage,
    enProductPage,
    enCartPage,
    enFormInputs,
    enInputs,
    enErrors,
    enFooter,
} from './utils/imports/import-translations';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: ['fr', 'en', 'de'],
        interpolation: {
            escapeValue: false,
        },
        resources: {
            fr: {
                translation: {
                    shop: frShopPage,
                    product: frProductPage,
                    cart: frCartPage,
                    formInputs: frFormInputs,
                    inputs: frInputs,
                    errors: frErrors,
                    footer: frFooter,
                },
            },
            en: {
                translation: {
                    shop: enShopPage,
                    product: enProductPage,
                    cart: enCartPage,
                    formInputs: enFormInputs,
                    inputs: enInputs,
                    errors: enErrors,
                    footer: enFooter,
                },
            }
        },
    });

export default i18n;